import { Stack } from '@mui/material'
import moment from 'moment'
import type React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { useGetActivityFeedForSubjectQuery } from '@/lib/apollo'

import SlideInSidebar from './DEPRECATED_UI/SlideInSidebar'
import FooterBackButton from './FooterBackButton'
import H2 from './H2'
import LoadingSpinner from './LoadingSpinner'
import UnexpectedError from './UnexpectedError'

interface Props {
  customerId: string
  applicationId: string
  subjectId: string
  onClose: () => void
  applicationName: string | undefined
}

const ActivityChild = styled.div`
  display: grid;
  grid-template-columns: 20px 1fr;
  align-items: baseline;
  grid-gap: 5px;
  margin: 10px;
  border-radius: 10px;
  padding: 20px;

  &:hover {
    background: #f2f2f2;
  }

  > div {
    display: flex;
    flex-flow: row wrap;

    div:nth-child(1) {
      display: flex;
      flex-flow: column;
    }
    div:nth-child(2) {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      column-gap: 10px;
      font-size: 0.8rem;

      > span:nth-child(2) {
        text-align: right;
      }
    }

    #time,
    #name {
      font-weight: 700;
    }

    #desc:first-letter {
      text-transform: capitalize;
    }

    #message {
      margin-top: 10px;
      text-align: left;
      white-space: pre-wrap;
    }
    #message:first-letter,
    #desc:first-letter {
      text-transform: capitalize;
    }
  }

  img {
    max-width: 12px;
  }
`

const ActivityList = styled.div`
  overflow-y: auto;
`

const Container = styled.div`
  margin-top: 10px;
  display: grid;
  gap: 20px;
`

const SubjectActivityFeed: React.FC<Props> = ({
  applicationId,
  customerId,
  subjectId,
  onClose,
}) => {
  const { loading, error, data, refetch } = useGetActivityFeedForSubjectQuery({
    variables: {
      customerId,
      applicationId,
      subjectId,
    },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  })

  return (
    <SlideInSidebar
      onClose={onClose}
      header={
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
          <H2>Notifications</H2>
          <Link to={`/applicant/${subjectId}/change-log`}>View change log</Link>
        </Stack>
      }
      content={
        <Container>
          {loading ? (
            <LoadingSpinner size="2x" />
          ) : error ? (
            <UnexpectedError error={error} onRetry={() => refetch()} />
          ) : (
            <ActivityList>
              {data?.getActivityFeedForSubject.map((act, index) => (
                <ActivityChild key={index}>
                  <img
                    src={`/assets/svg/${act.type === 'event' ? 'calendar' : 'info'}.svg`}
                    alt=""
                    style={{
                      marginRight: 5,
                    }}
                  />
                  <div>
                    <div>
                      <span id="desc">
                        <strong>{act.desc}</strong>
                      </span>
                      <span id="message">{act.message}</span>
                    </div>
                    <div>
                      <span id="name">
                        Actioned by <span>{act.createdBy}</span>
                      </span>

                      <span id="time">{moment(act.timestamp).format('LLL')}</span>
                    </div>
                  </div>
                </ActivityChild>
              ))}
            </ActivityList>
          )}
        </Container>
      }
      footer={<FooterBackButton onClick={onClose} />}
    />
  )
}

export default SubjectActivityFeed
